import React, { Component } from "react";
import { slide as Menu } from 'react-burger-menu'
import Link from 'gatsby-link'
import Retrato from "../images/retrato.jpg";
import EmailIcon from 'react-icons/lib/md/email'
import HomeIcon from 'react-icons/lib/md/home'
import MobileIcon from 'react-icons/lib/md/phone-iphone'
import ShoppingIcon from 'react-icons/lib/md/shopping-cart'


class MainMenu extends Component {

  showSettings (event) {
    event.preventDefault();    
  }
 
  render () {
    return (
      <Menu>
        <div className='acerca-de'>
          <a href="/acerca-de"><img src={Retrato} className='circle' /></a>
          <div><a href="/acerca-de">Acerca de mi</a></div>
        </div>
        <hr />
        <div className="collection">
          <a className="collection-item blue-grey-text text-darken-2" href="/"><HomeIcon /> Inicio</a>                
          <a className="collection-item blue-grey-text text-darken-2" href="/contacto"><EmailIcon /> Contáctame</a>
          <a className="collection-item blue-grey-text text-darken-2" href="/comprar"><ShoppingIcon /> ¿Cómo comprar?</a>
          <a className="collection-item blue-grey-text text-darken-2" href="tel:+50683075983"><MobileIcon /> 8307-5983</a>
        </div>
      </Menu>
    );
  }
}

export default MainMenu;




// WEBPACK FOOTER //
// ./src/layouts/main-menu.js